export const saveFileFromBase64 = async (base64String, fileName) => {
  return base64String;
};
